import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/service/AllInvestment.jsx");
